export class UngroupedProviderSelectDialog {
  providers: {label: string; value: string; disabled: boolean; selected: boolean}[];
  single: boolean;
}
